import React from 'react';
import {clsx} from 'clsx';

import tallyStyle from './icon.module.styl';

const EventsTallyIcon = ({className}: {className: string}) => {
  return (
    <div className={clsx(className, tallyStyle.iconContainer)}>
      <svg width='40' height='40' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g>
          {/* Static gray background circle */}
          <circle
            className={tallyStyle.staticStroke}
            cx='30'
            cy='30'
            r='28'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
          />

          {/* Rotating purple segments (visible when not loaded) */}
          <g className={tallyStyle.spinner}>
            <path
              className={tallyStyle.spinnerStroke}
              d='M30 2 A28 28 0 0 1 58 30'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
            <path
              className={tallyStyle.spinnerStroke}
              d='M30 58 A28 28 0 0 1 2 30'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </g>

          {/* Complete purple circle (visible when loaded) */}
          <circle
            className={tallyStyle.iconCircle}
            cx='30'
            cy='30'
            r='28'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
          />

          {/* Replays icon (always visible) */}
          <g className={tallyStyle.icon}>
            <path
              className={tallyStyle.iconPathFill}
              d='M10.1973 8.24121L10.3818 8.28809L19.124 11.2031L19.2793 11.2686C20.003 11.6515 19.9266 12.7768 19.085 13.0176L14.9443 14.1992L13.6846 18.6016C13.4454 19.4363 12.3328 19.5206 11.9424 18.8076L11.875 18.6543L8.80664 9.8877C8.48502 8.96877 9.28432 8.07859 10.1973 8.24121ZM12.7188 16.5254L13.6182 13.3867L13.7324 12.9863L14.1328 12.8721L16.9619 12.0635L10.3906 9.87305L12.7188 16.5254ZM6.16992 11.2197C6.46285 10.9269 6.93763 10.9268 7.23047 11.2197C7.5232 11.5126 7.52319 11.9874 7.23047 12.2803L5.81543 13.6943C5.5225 13.987 5.04769 13.9872 4.75488 13.6943C4.46229 13.4015 4.46229 12.9266 4.75488 12.6338L6.16992 11.2197ZM5.57715 8.25391C5.95512 8.29253 6.25 8.61183 6.25 9C6.25 9.38817 5.95512 9.70747 5.57715 9.74609L5.5 9.75H3.5C3.08579 9.75 2.75 9.41421 2.75 9C2.75 8.58579 3.08579 8.25 3.5 8.25H5.5L5.57715 8.25391ZM13.543 4.2832C13.8358 3.99046 14.3107 3.9904 14.6035 4.2832C14.8963 4.57605 14.8963 5.05086 14.6035 5.34375L13.1895 6.75781C12.8966 7.05074 12.4218 7.05067 12.1289 6.75781C11.8361 6.46494 11.8361 5.99014 12.1289 5.69727L13.543 4.2832ZM4.78418 4.2832C5.07712 3.99053 5.55193 3.99034 5.84473 4.2832L7.25879 5.69727L7.31055 5.75488C7.55025 6.04932 7.53283 6.48337 7.25879 6.75781C6.98428 7.03226 6.54943 7.04956 6.25488 6.80957L6.19727 6.75781L4.7832 5.34375C4.49059 5.05081 4.49134 4.57598 4.78418 4.2832ZM9.5 2.25C9.91421 2.25 10.25 2.58579 10.25 3V5C10.25 5.41421 9.91421 5.75 9.5 5.75C9.08579 5.75 8.75 5.41421 8.75 5V3C8.75 2.58579 9.08579 2.25 9.5 2.25Z'
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export {EventsTallyIcon};
